/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import {
  Avatar, Column, Img, Row, Text, Divider,
} from './styels';
import icon from '../../constants/icons';
import color from '../../constants/color';

interface Props {
    id: string;
    imagem?: string;
    nome: string;
    labelId?: string;
    check: boolean;
    action?: Function;
    isBlue?: boolean;
}

const ItemListModal: React.FC<Props> = ({
  id,
  imagem,
  nome,
  check,
  action,
  isBlue,
}) => (
  <Column>
    <Row key={id} onClick={() => action && action(id)}>
      <Img src={check ? icon.checkIcon : icon.unCheckIcon} />
      {imagem && (
        <Avatar src={imagem} />
      )}
      <Text style={{ color: isBlue ? color.blue : undefined }}>{nome}</Text>
    </Row>
    <Divider />
  </Column>
);
export default ItemListModal;
